(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('LiberarDialogController', LiberarDialogController);

    LiberarDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'SSAsignacion', 'CartaLiberacionDownloadService', 'AlertService'];

    function LiberarDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, SSAsignacion, CartaLiberacionDownloadService, AlertService) {
        var vm = this;

        entity.$promise.then(function(result) {
        	vm.sSAsignacion = result;
        });

        vm.numExpediente = "";
        vm.clear = clear;
        vm.save = save;
        
        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            SSAsignacion.liberar({
        		idAsignacion: vm.sSAsignacion.id, 
        		numExpediente: vm.numExpediente
            }, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess (result) {
        	CartaLiberacionDownloadService.download(vm.sSAsignacion.id, vm.sSAsignacion.prestador.matriculaParteInvariable)
            .then(function(data) {
            	onDownloadSuccess(vm.sSAsignacion.id);
            })
            .catch(function(err) {
            	onDownloadError();
            });
        }
        	
        function onSaveError () {
            vm.isSaving = false;
        	AlertService.error("Ocurrió un error al liberar al alumno.");
        }

        function onDownloadSuccess(result){
            $scope.$emit('serviciosocialApp:sSProyectoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onDownloadError () {
            vm.isSaving = false;
        	AlertService.error("Ocurrió un error al generar la carta de liberación");
        }

    }
})();
